import { BaseDrawer } from 'reservations/base/components/BaseDrawer';
import { WAITLIST_ESTIMATE_INFO_SUBHEADER } from 'reservations/waitlist/constants';

export const WaitlistEstimateModal = () => (
  <BaseDrawer
    header="WAIT TIME ESTIMATE"
    subheader={WAITLIST_ESTIMATE_INFO_SUBHEADER}
    secondaryButton={{ label: 'CLOSE' }}
  />
);
